<template>
<div id="login-page">
  <v-container fluid grid-list-xl>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm8 md6 lg5>
        <v-card color="grey lighten-2">
          <v-container>
            <h2 class="headline">Sign in</h2>
            <p class="caption">Please fill out and submit the form below</p>
            <LoginForm/>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import LoginForm from '@/components/LoginForm'

export default {
  components: {
    LoginForm
  }
}
</script>

<style scoped>
#login-page {
  font-family: 'Lato', sans-serif;
  font-size: 1.2vmax;
}
#slogan {
  font-size: 2vmax;
  font-family: 'Vollkorn', serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.page-subheading {
  font-size: 2vmax;
}
</style>


// WEBPACK FOOTER //
// src/admin_pages/LoginPage.vue